/*
 Copyright 2019 Google Inc. All Rights Reserved.
 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/

export async function fetchWithFallback(
    request: Request,
    fallbackUrl: string,
    cacheName: string,
) {
  try {
    const response = await fetch(request);

    // Successful but error-like responses are treated as failures.
    // Ditto for redirects to other origins.
    if (!response.ok || (new URL(response.url).origin !== location.origin)) {
      throw Error('Fallback request failure.');
    }

    return response;
  } catch (e) {
    const cache = await caches.open(cacheName);
    return cache.match(fallbackUrl);
  }
}
